import { useCoralTheme } from '@krakentech/coral';

const Chart = () => {
  const { color } = useCoralTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="76"
      viewBox="0 0 48 76"
      fill="none"
    >
      <rect
        width="17.6327"
        height="40.4675"
        transform="translate(4.89844 30.5974)"
        fill={color.primary.main}
      />
      <rect
        width="17.6327"
        height="68.1039"
        transform="translate(26.4492 2.96106)"
        fill={color.primary.main}
      />
      <rect width="0.979592" height="76" fill={color.primary.main} />
      <rect
        width="0.987013"
        height="47.0204"
        transform="matrix(0 -1 1 0 0.979492 76)"
        fill={color.primary.main}
      />
    </svg>
  );
};

export default Chart;
